import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import {
  CLICKED_SUGGESTION_KEY,
  PERSISTENT_ANALYTICS_DATA_KEY,
} from '../../../tools/constants';
import saveRecentSearch from '../../../tools/recentSearches';
import { triggerSearchTermAnalytics } from '../../../tools/triggerAnalytics';
import { SEARCH_RESULTS_PAGE_DATA } from '../queries';

const useSearchResponse = (parameters) => {
  const [completionType] = useLocalStorage(CLICKED_SUGGESTION_KEY, []);
  const [algonomyPersistentData,, removeAlgonomyPersistentData] = useLocalStorage(
    PERSISTENT_ANALYTICS_DATA_KEY, {},
  );
  const [resolvedSearchTerm, setResolvedSearchTerm] = useState(parameters.searchTerm);
  const [resolvedDepartmentId, setResolvedDepartmentId] = useState(parameters.departmentId);
  const isInitialSearch = parameters.submitMethod === 'toaster';

  const {
    data,
    previousData,
    loading,
    error,
  } = useQuery(SEARCH_RESULTS_PAGE_DATA, {
    variables: {
      countryFulfillmentStore: parameters.countryFulfillmentStore,
      departmentId: parameters.departmentId,
      facet: parameters.facet,
      filter: parameters.filter,
      initialSearchTerm: parameters.initialSearchTerm,
      isSemantic: parameters.isSemantic,
      rows: parameters.rows,
      searchTerm: parameters.searchTerm,
      sort: parameters.sort,
      start: parameters.start,
    },
    skip: !parameters.searchTerm,
  });

  useEffect(() => {
    if (!data) return;

    const {
      searchResults: {
        suggestedSearchTerm = null,
        departmentId,
        productTotalCount: resultsCount,
      } = {},
    } = data;

    const finalSearchTerm = suggestedSearchTerm || parameters.searchTerm;
    const finalDepartmentId = departmentId || parameters.departmentId;
    setResolvedSearchTerm(finalSearchTerm);
    setResolvedDepartmentId(finalDepartmentId);
    if (resultsCount > 0) saveRecentSearch(finalSearchTerm);

    triggerSearchTermAnalytics({
      actionType: parameters.actionType,
      algonomyPersistentData,
      completionType,
      departmentId: parameters.departmentId,
      isInitialSearch,
      previousSearchterm: parameters.previousSearchterm,
      resultsCount: resultsCount || 0,
      removeAlgonomyPersistentData,
      searchTerm: suggestedSearchTerm,
      submitMethod: parameters.submitMethod,
      userInputedSearchTerm: parameters.userInputedSearchTerm || parameters.searchTerm,
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    completionType,
    data,
    isInitialSearch,
    parameters.actionType,
    parameters.previousSearchterm,
    parameters.searchTerm,
    parameters.submitMethod,
    parameters.userInputedSearchTerm,
    parameters.departmentId,
  ]);

  return {
    resolvedDepartmentId,
    resolvedSearchTerm,
    setResolvedSearchTerm,
    data,
    previousData,
    loading,
    error,
  };
};

export default useSearchResponse;
